<router-outlet></router-outlet>
<joyridestep joyrideStep="firstStep" title="Willkommen bei der Lithos 3D-App" text="Lernen Sie mit Hilfe dieses Tutorials die Lithos-3D-App und ihre Funktionen kennen. Es dauert nur ein paar Augenblicke." stepPosition="center"></joyridestep>

<div *ngIf="uiService.isJoomla" id="joomlaLoginScreen">
    <img class="behindImg" src="assets/images/joomla-logo.png">
</div>
